module.exports = ".document {\n  margin-bottom: 15px; }\n  @media screen and (max-width: 290px) {\n    .document {\n      -webkit-box-flex: 0;\n          -ms-flex: 0 0 100%;\n              flex: 0 0 100%;\n      max-width: 100%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/documents-list/documents-grid/documents-grid.component.scss
// module id = ./src/app/shared/documents-list/documents-grid/documents-grid.component.scss
// module chunks = main